import { render, staticRenderFns } from "./ButtonSectionSelect.vue?vue&type=template&id=25b38c90&scoped=true&"
import script from "./ButtonSectionSelect.vue?vue&type=script&lang=js&"
export * from "./ButtonSectionSelect.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSectionSelect.vue?vue&type=style&index=0&id=25b38c90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b38c90",
  null
  
)

export default component.exports